<dx-popup
  [width]="'90%'"
  [maxWidth]="450"
  [height]="300"
  [showTitle]="false"
  [dragEnabled]="false"
  [hideOnOutsideClick]="false"
  [showCloseButton]="true"
  class="modal"
  [classList]="'modal'"
  [visible]="showModal"
  (onHidden)="dismiss()"
>
  <div *dxTemplate="let data of 'content'">
    <div class="decline-message">
      <h2 class="decline-title">
        {{ 'MY-INVITATION.DECLINE-INVITATION.TITLE' | translate }}
      </h2>
      <div class="decline-text">
        {{ 'MY-INVITATION.DECLINE-INVITATION.TEXT' | translate }}  
      </div>
    </div>
  </div>

  <dxi-popup-toolbar-item
    widget="dxButton"
    toolbar="bottom"
    location="before"
    [options]="{
      type: 'normal',
      text: 'COMMON.CANCEL' | translate,
      onClick: dismiss
    }"
  ></dxi-popup-toolbar-item>
  <dxi-popup-toolbar-item
    widget="dxButton"
    toolbar="bottom"
    location="after"
    [options]="{
      type: 'danger',
      stylingMode: 'contained',
      text: 'COMMON.DECLINE' | translate,
      onClick: declineInvitation
    }"
  ></dxi-popup-toolbar-item>
</dx-popup>
